export default {
    authenticate(username, password, success, error)
    {
        setTimeout(() =>
        {
            if (Math.random() > 0.5)
            {
                success('random token');
            }
            else
            {
                error('error');
            }
        }, 100);
    },
};
